import { createWorkletExecutor } from "./background/executor.native";
import { createLatestComputation } from "./background/createLatestComputation";
import { useBackgroundComputation } from "./background/useBackgroundComputation";
function defineBackgroundComputation(calculate) {
  return Object.freeze({
    createExecutor: function createExecutor() {
      return createWorkletExecutor(calculate);
    }
  });
}
export {
  createLatestComputation,
  defineBackgroundComputation,
  useBackgroundComputation
};
//# sourceMappingURL=background.native.js.map
